import React, { useEffect, useState } from "react";
import MyGoogleMap from "../../components/MyGoogleMap";
import NavbarPag from "../../components/NavbarPag";
import { useData } from "../../contexts/DataContext";
import { useLocation, useNavigate } from "react-router-dom";

const SearchOdPublic = () => {
  const { rutInit, od } = useData();
  const { dataR } = useLocation().state || {};
  const navigate = useNavigate();

  let lisState = ["INICIAL", "RETIRADO", "ENTREGADO", "NO ENTREGADO"];
  const [state, setState] = useState("");
  const [name, setName] = useState("");
  const [date, setDate] = useState("");
  const [nota, setNota] = useState("");
  let [imgSrc, setImgSrc] = useState("");
  let [numb, setNumb] = useState("");
  let [photo, setPhoto] = useState(0);
  const [imageSrc, setImageSrc] = useState("");
  const [cordenadas, setCordenadas] = useState({ lat: 0, lng: 0 });
  const [rut, setRut] = useState("");
  const [errorOd, setErrorOd] = useState(true);

  // Detalle de la orden para vista pública
  const [origin, setOrigin] = useState("");
  const [destination, setDestination] = useState("");
  const [recipient, setRecipient] = useState("");
  const [sender, setSender] = useState("");
  const [address, setAddress] = useState("");

  // Helper para mostrar "EN RUTA" cuando el estado es "INICIAL"
  const displayState = (s: string) => (s === "INICIAL" ? "EN RUTA" : s);

  useEffect(() => {
    // Datos que vienen por navegación - con verificación defensiva
    if (dataR && dataR.orders && dataR.deliveries) {
      setName(dataR.orders.name ? dataR.orders.name : "");
      setCordenadas(
          dataR.orders.latitude
              ? { lat: Number(dataR.orders.latitude), lng: Number(dataR.orders.longitude) }
              : { lat: 0, lng: 0 }
      );
      setRut(dataR.orders.latitude ? dataR.orders.rut : "");

      // Set de campos extra si existen en dataR.orders
      setOrigin(dataR.orders.ciudad ? dataR.orders.ciudad : "");
      setDestination(dataR.orders.Destino ? dataR.orders.Destino : "");
      setRecipient(dataR.orders.destinatario ? dataR.orders.destinatario : "");
      setSender(
          dataR.orders.remitente
              ? dataR.orders.remitente
              : dataR.orders.Centro_de_costos
                  ? dataR.orders.Centro_de_costos
                  : ""
      );
      setAddress(dataR.orders.direccion ? dataR.orders.direccion : "");

      if (dataR.orders.date) {
        const fecha = new Date(dataR.orders.date);
        const dia = fecha.getDate();
        const mes = fecha.getMonth() + 1;
        const year = fecha.getFullYear();
        const hours = fecha.getHours();
        const minnute = fecha.getMinutes();
        setDate(
            `${dia < 10 ? "0" + dia : dia}/${mes < 10 ? "0" + mes : mes}/${year} Hora ${
                hours < 10 ? "0" + hours : hours
            }:${minnute < 10 ? "0" + minnute : minnute}`
        );
        if (dataR.orders.photo) {
          setPhoto(dataR.orders.photo.length);
          setImageSrc(`data:image/jpeg;base64,${dataR.orders.photo}`);
        } else {
          setImageSrc("");
        }
      }

      setNumb(dataR.orders.uuid);

      const rawStateFromDataR = lisState[dataR.deliveries.state] ?? "";
      setState(displayState(rawStateFromDataR));

      setErrorOd(false);
    }
  }, []);

  const [odValue, setOdValue] = useState(od);
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setOdValue(event.target.value);
  };

  const search = async () => {
    const apiUrl = process.env.NODE_ENV === 'development' 
      ? 'http://localhost:5001/api' 
      : 'https://api-kdps2abp6q-uc.a.run.app/api';
    
    try {
      const response = await fetch(`${apiUrl}?id=${odValue}`);
      if (!response.ok) {
        throw new Error('Error en la respuesta del servidor');
      }
      const data = await response.json();
      const orders = data.orders;
      const deliveries = data.deliveries;

      if (deliveries.length === 0) {
        setErrorOd(true);
      } else {
        const data1 = orders[0];
        const data2 = deliveries[0];
        let stateD = data2.state;
        const lis1 = Object.keys(data1);
        const lis2 = Object.keys(data2);
        setErrorOd(false);

        const rawState = lisState[stateD] ?? "";
        setState(displayState(rawState));

        setName(lis1.includes("name") ? data1.name : "");
        setCordenadas(
            lis1.includes("latitude")
                ? { lat: Number(data1.latitude), lng: Number(data1.longitude) }
                : { lat: 0, lng: 0 }
        );
        setRut(lis1.includes("latitude") ? data1.rut : "");

        // Set de campos extra si existen
        setOrigin(lis1.includes("ciudad") ? data1.ciudad : "");
        setDestination(lis1.includes("Destino") ? data1.Destino : "");
        setRecipient(lis1.includes("destinatario") ? data1.destinatario : "");
        setSender(
            lis1.includes("remitente")
                ? data1.remitente
                : lis1.includes("Centro_de_costos")
                    ? data1.Centro_de_costos
                    : ""
        );
        setAddress(lis1.includes("direccion") ? data1.direccion : "");

        if (lis1.includes("date")) {
          const fecha = new Date(data1.date);
          const dia = fecha.getDate();
          const mes = fecha.getMonth() + 1;
          const year = fecha.getFullYear();
          const hours = fecha.getHours();
          const minnute = fecha.getMinutes();
          setDate(
              `${dia < 10 ? "0" + dia : dia}/${mes < 10 ? "0" + mes : mes}/${year} Hora ${
                  hours < 10 ? "0" + hours : hours
              }:${minnute < 10 ? "0" + minnute : minnute}`
          );
        }
        setNota(lis1.includes("comment") ? data1.comment : "");
        if (lis1.includes("photo")) {
          setPhoto(data1.photo.length);
          setImageSrc(`data:image/jpeg;base64,${data1.photo}`);
        } else {
          setImageSrc("");
        }
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setErrorOd(true);
    }
  };
  useEffect(() => {
    if (od !== "") {
      setOdValue(od);
      search();
    }
  }, []);

  const back = () => {
    navigate("/");
  };
  if (rutInit !== "") {
    return <div></div>;
  }

  return (
      <div className={errorOd ? "w-screen h-screen" : "w-screen"}>
        {/* navbar */}

        <div className=" h-full bg-neutral-200 overflow-hidden flex flex-col items-center">
          <div className=" w-11/12">
            <h2 className="text-2xl text-center p-3">Rastreo de Guía</h2>
            <div className="bg-sky-600 p-2 text-white">
              Número de orden {numb}
            </div>
            <article className="mt-5">
              <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" onClick={back}>
                Volver
              </button>
            </article>

            <div className=" m-2 p-1">
              {errorOd ? <div className="text-2xl text-sky-700">NO EXISTE INFORMACION DE LA ORDEN</div> : ""}
            </div>

            {!errorOd ? (
                <article className=" bg-slate-50">
                  <div className=" bg-neutral-300 p-2 text-gray-700 mt-2">
                    ESTADO ACTUAL - <span className="text-green-500">{state}</span>(NORMAL)
                  </div>
                  <div className="flex p-3">
                    <div className=" w-1/3">
                      <div>
                        <span className=" text-sky-700">Nombre receptor: </span> {name}
                      </div>
                      <div>
                        <span className=" text-sky-700">Estado: </span> {state}
                      </div>
                      <div>
                        <span className=" text-sky-700">Cordenadas de destino:</span> {cordenadas.lat},{cordenadas.lng}
                      </div>
                      <div>
                        <span className=" text-sky-700">Origen: </span> {origin}
                      </div>
                      <div>
                        <span className=" text-sky-700">Destino: </span> {destination}
                      </div>
                    </div>
                    <div className=" w-1/3">
                      <div>
                        <span className=" text-sky-700"> Rut receptor: </span> {rut}
                      </div>
                      <div>
                        <span className=" text-sky-700">Fecha gestion: </span> {date}
                      </div>
                      <div>
                        <span className=" text-sky-700">Dirección: </span> {address}
                      </div>
                    </div>
                    <div className=" w-1/3">
                      <div>
                        <span className=" text-sky-700"> Destinatario: </span> {recipient}
                      </div>
                      <div>
                        <span className=" text-sky-700"> Remitente: </span> {sender}
                      </div>
                      <div>
                        <span className=" text-sky-700"> Codigo biometrico: </span> False
                      </div>
                      <div>
                        <span className=" text-sky-700"> Tipo certificación: </span> Normal
                      </div>
                    </div>
                  </div>
                </article>
            ) : (
                ""
            )}

            {!errorOd ? (
                <article className="flex p-5">
                  <div className=" w-1/2 p-3 ">
                    <div className=" w  bg-neutral-300">
                      <div className=" text-sky-700 p-1 pl-3">Punto Destino</div>
                      <div>{cordenadas.lat !== 0 && cordenadas.lng !== 0 ? <MyGoogleMap center={cordenadas} /> : ""}</div>
                    </div>
                  </div>
                  <div className=" w-1/2 p-3 ">
                    <div className=" w  bg-neutral-300">
                      <div className=" text-sky-700 p-1 pl-3">Evidencia de gestion</div>
                      {photo > 0 ? (
                          <img className=" ml-auto mr-auto" src={imageSrc} alt="Imagen en Base64" />
                      ) : (
                          ""
                      )}
                    </div>
                  </div>
                </article>
            ) : (
                ""
            )}
          </div>
        </div>
      </div>
  );
};

export default SearchOdPublic;
